import React from "react";

interface VisibilityProps {
  className?: string;
  on?: boolean;
}

const Visibility: React.FC<VisibilityProps> = ({ className, on = true }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {on ? (
        <path
          d="M8.00002 3C4.66669 3 1.82002 5.07333 0.666687 8C1.82002 10.9267 4.66669 13 8.00002 13C11.3334 13 14.18 10.9267 15.3334 8C14.18 5.07333 11.3334 3 8.00002 3ZM8.00002 11.3333C6.16002 11.3333 4.66669 9.84 4.66669 8C4.66669 6.16 6.16002 4.66667 8.00002 4.66667C9.84002 4.66667 11.3334 6.16 11.3334 8C11.3334 9.84 9.84002 11.3333 8.00002 11.3333ZM8.00002 6C6.89335 6 6.00002 6.89333 6.00002 8C6.00002 9.10667 6.89335 10 8.00002 10C9.10669 10 10 9.10667 10 8C10 6.89333 9.10669 6 8.00002 6Z"
          fill="var(--icon)"
        />
      ) : (
        <path
          d="M8.00325 4.33329C9.84326 4.33329 11.3366 5.82663 11.3366 7.66663C11.3366 8.09996 11.2499 8.50663 11.0966 8.88663L13.0433 10.8333C14.0499 9.99329 14.8433 8.90663 15.3299 7.66663C14.1766 4.73996 11.3299 2.66663 7.99659 2.66663C7.06325 2.66663 6.16992 2.83329 5.34326 3.13329L6.78326 4.57329C7.16325 4.41996 7.56992 4.33329 8.00325 4.33329ZM1.33659 2.51329L3.16325 4.33996C2.05659 5.19996 1.18992 6.34663 0.669922 7.66663C1.82326 10.5933 4.66992 12.6666 8.00325 12.6666C9.03659 12.6666 10.0233 12.4666 10.9233 12.1066L11.2033 12.3866L13.1566 14.3333L14.0033 13.4866L2.18326 1.66663L1.33659 2.51329ZM5.02325 6.19996L6.05659 7.23329C6.02325 7.37329 6.00325 7.51996 6.00325 7.66663C6.00325 8.77329 6.89659 9.66663 8.00325 9.66663C8.14992 9.66663 8.29659 9.64663 8.43659 9.61329L9.46992 10.6466C9.02325 10.8666 8.52992 11 8.00325 11C6.16325 11 4.66992 9.50663 4.66992 7.66663C4.66992 7.13996 4.80326 6.64663 5.02325 6.19996ZM7.89659 5.67996L9.99659 7.77996L10.0099 7.67329C10.0099 6.56663 9.11659 5.67329 8.00992 5.67329L7.89659 5.67996Z"
          fill="var(--icon)"
        />
      )}
    </svg>
  );
};

export default Visibility;
